import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ClearRounded from "@mui/icons-material/ClearRounded";
import { AuthState } from "../../context/AuthContext";
import { RoleChips } from "components/Users/shared/RoleAccessSection";
import {
	UserTypeChip,
	colorFromName,
	getInitials,
	userUi,
} from "components/Users/shared/userUi";

const dash = (value) => (value == null || String(value).trim() === "" ? null : value);

const DetailRow = ({ label, value }) => {
	if (!value) return null;
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "flex-start",
				justifyContent: "space-between",
				gap: 2,
				py: 1.25,
				borderBottom: `1px solid ${userUi.border}`,
			}}>
			<Typography sx={{ fontSize: 13, fontWeight: 500, color: userUi.textSecondary, flexShrink: 0 }}>
				{label}
			</Typography>
			<Typography sx={{ fontSize: 14, fontWeight: 500, color: userUi.textPrimary, textAlign: "right" }}>
				{value}
			</Typography>
		</Box>
	);
};

const Profile = ({ setModalOpen }) => {
	const { user } = AuthState();

	if (!user) return null;

	return (
		<Paper
			elevation={0}
			sx={{
				width: { xs: "92vw", sm: 440 },
				maxWidth: 440,
				maxHeight: "80vh",
				overflow: "auto",
				borderRadius: 2,
				border: `1px solid ${userUi.border}`,
				boxShadow: "0 8px 24px rgba(16, 24, 40, 0.12)",
				outline: "none",
			}}>
			<Box sx={{ position: "relative" }}>
				<Box
					sx={{
						px: 3,
						pt: 2.5,
						pb: 2,
						borderBottom: `1px solid ${userUi.border}`,
						bgcolor: "#FAFAFA",
					}}>
					<Typography sx={{ fontWeight: 600, fontSize: 20, letterSpacing: "-0.01em", color: userUi.textPrimary }}>
						Profile
					</Typography>
					<Typography sx={{ color: userUi.textSecondary, mt: 0.5, fontSize: 14 }}>
						Your account details and access
					</Typography>
				</Box>
				<IconButton
					onClick={() => setModalOpen(false)}
					size="small"
					sx={{ position: "absolute", top: 16, right: 16 }}>
					<ClearRounded fontSize="small" />
				</IconButton>
			</Box>

			<Box sx={{ px: 3, py: 2.5 }}>
				<Box display="flex" alignItems="center" gap={1.75} pb={2.25} mb={0.5} borderBottom={`1px solid ${userUi.border}`}>
					<Avatar
						sx={{
							width: 52,
							height: 52,
							fontSize: 18,
							fontWeight: 700,
							bgcolor: colorFromName(user.name),
						}}>
						{getInitials(user.name)}
					</Avatar>
					<Box minWidth={0}>
						<Typography sx={{ fontWeight: 600, fontSize: 18, color: userUi.textPrimary, lineHeight: 1.3 }}>
							{user.name || "—"}
						</Typography>
						<Box display="flex" alignItems="center" gap={1} mt={0.5} flexWrap="wrap">
							{user.designation ? (
								<Typography sx={{ fontSize: 13, color: userUi.textSecondary }}>{user.designation}</Typography>
							) : null}
							{user.type ? <UserTypeChip label={user.type} /> : null}
						</Box>
					</Box>
				</Box>

				<DetailRow label="Email" value={dash(user.email)} />
				<DetailRow label="Department" value={dash(user.department)} />
				<DetailRow label="Employee ID" value={dash(user.employee_id)} />
				<DetailRow label="Mobile" value={dash(user.mobile_no)} />

				<Box pt={2}>
					<Typography sx={{ fontSize: 13, fontWeight: 500, color: userUi.textSecondary, mb: 1 }}>
						Access
					</Typography>
					<RoleChips role={user.role} emptyLabel="No access assigned" />
				</Box>
			</Box>
		</Paper>
	);
};

export default Profile;
